/* Mutha LP cart button — auto-binds any <form data-mutha-cart-form>:
   POSTs to /cart/add.js, plays an optimistic "added" animation on the
   submit button, and dispatches a 'cart:update' event so Horizon's
   cart drawer + cart icon refresh.

   Discount auto-apply (upgrade-eye-reset flow):
   When the landing URL carries ?discount=CODE (Klaviyo replaces this with
   the customer's unique coupon code), the code is captured once at page
   load and silently applied to the cart session on the first ATC click
   via GET /discount/CODE (redirect:manual). Shopify attaches the code
   to the session cart; the cart drawer and checkout pick it up
   automatically — no extra UI plumbing needed. */
(function () {
  if (window.__muthaLpCartButtonLoaded) return;
  window.__muthaLpCartButtonLoaded = true;

  // Capture ?discount=CODE once. Sanity-check: codes are short, alphanum + dash/underscore.
  var discountCode = '';
  try {
    var params = new URLSearchParams(window.location.search);
    var raw = (params.get('discount') || '').trim();
    if (raw && /^[A-Za-z0-9_-]{1,64}$/.test(raw)) {
      discountCode = raw;
    }
  } catch (e) { /* very old browser — fall back to no-discount flow */ }
  var discountApplied = false;
  var discountInFlight = null;

  function applyDiscount() {
    if (!discountCode || discountApplied) return Promise.resolve();
    if (discountInFlight) return discountInFlight;
    discountInFlight = fetch('/discount/' + encodeURIComponent(discountCode), {
      method: 'GET',
      redirect: 'manual',
      credentials: 'same-origin',
    })
      .then(function () { discountApplied = true; })
      .catch(function () { /* swallow — discount is non-blocking; cart still proceeds */ })
      .finally(function () { discountInFlight = null; });
    return discountInFlight;
  }

  function bind(form) {
    if (form.dataset.muthaCartBound === '1') return;
    form.dataset.muthaCartBound = '1';

    var btn = form.querySelector('button[type="submit"]');
    var statusEl = form.querySelector('[data-mutha-cart-status]');
    var resetTimeout;

    function setError(msg) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
      statusEl.classList.toggle('mlp-cart-form__status--error', !!msg);
    }

    function playAddedAnimation() {
      if (!btn) return;
      if (resetTimeout) clearTimeout(resetTimeout);
      btn.classList.add('mlp-added');
      resetTimeout = setTimeout(function () {
        btn.classList.remove('mlp-added');
      }, 1400);
    }

    function rollbackAnimation() {
      if (resetTimeout) clearTimeout(resetTimeout);
      if (btn) btn.classList.remove('mlp-added');
    }

    function doAddToCart() {
      var fd = new FormData(form);
      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });
      if (sectionIds.length) fd.append('sections', sectionIds.join(','));

      var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      return fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!btn || btn.disabled) return;

      btn.disabled = true;
      setError('');
      // Optimistic — show animation immediately on click (matches Horizon PDP behavior).
      playAddedAnimation();

      // Apply discount BEFORE add-to-cart so the /cart/add.js sections payload
      // reflects the credit in the drawer render that follows.
      applyDiscount()
        .then(doAddToCart)
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) {
            rollbackAnimation();
            setError(result.data && (result.data.description || result.data.message) || 'Could not add to cart');
            return;
          }
          var added = result.data || {};
          // Notify Horizon's cart-drawer + cart-icon (they listen on 'cart:update').
          // source 'product-form-component' tells cart-icon to increment instead of replace.
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: added,
              sourceId: form.id || '',
              data: {
                source: 'product-form-component',
                itemCount: 1,
                productId: String(added.product_id || ''),
                variantId: String(added.variant_id || ''),
                sections: added.sections || {},
              },
            },
          }));
        })
        .catch(function () {
          rollbackAnimation();
          setError('Network error. Please try again.');
        })
        .finally(function () {
          btn.disabled = false;
        });
    });
  }

  function init() {
    document.querySelectorAll('form[data-mutha-cart-form]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-bind after the theme editor reloads a section.
  document.addEventListener('shopify:section:load', init);
})();
